import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1 big-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "dialog container row m-0 p-1" }
const _hoisted_7 = { class: "form-group col-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "employee-to" }, " New User/Employee: ", -1 /* HOISTED */)
const _hoisted_9 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_10 = {
  key: 0,
  class: "form-group col-10"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "employee-to" }, " Reason: ", -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Type", -1 /* HOISTED */)
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Reason", -1 /* HOISTED */)
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 2,
  class: "field-invalid"
}
const _hoisted_18 = {
  key: 0,
  class: "d-flex justify-content-center mb-3 mt-1"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" })
], -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { else: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_FormSection, {
      "full-height": false,
      title: "Reassign",
      "application-id": _ctx.application,
      "show-product-pill": true,
      id: "bulk-reassign",
      "show-background": false
    }, {
      content: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
          : (_openBlock(), _createElementBlock("section", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_TypeaheadInput, {
                    getData: _ctx.filterEmployee,
                    value: _ctx.employee,
                    placeholder: "Enter Employee Name",
                    "show-all-by-default": _ctx.showAllByDefault,
                    onValueChanged: _ctx.selectedEmployeeChanged,
                    onBlurredInput: _ctx.v$.visitDetails.EmployeeTo.$touch,
                    class: _normalizeClass(`${!_ctx.v$.visitDetails.EmployeeTo.$error ? '' : 'field-invalid'}`)
                  }, null, 8 /* PROPS */, ["getData", "value", "show-all-by-default", "onValueChanged", "onBlurredInput", "class"]),
                  (_ctx.v$.visitDetails.EmployeeTo.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Employee is required."))
                    : _createCommentVNode("v-if", true)
                ]),
                (_ctx.isApplicationHomeCare)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _withDirectives(_createElementVNode("select", {
                        id: "reason-type",
                        name: "reason-type",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visitDetails.TypeId) = $event)),
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedType())),
                        class: _normalizeClass(`form-select ${!_ctx.v$.visitDetails.TypeId.$error ? '' : 'field-invalid'}`),
                        onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.v$.visitDetails.TypeId.$touch && _ctx.v$.visitDetails.TypeId.$touch(...args)))
                      }, [
                        _hoisted_12,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trackingTypes, (trackingType) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: trackingType.Id,
                            key: trackingType.Id
                          }, _toDisplayString(trackingType.Name), 9 /* TEXT, PROPS */, _hoisted_13))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 34 /* CLASS, HYDRATE_EVENTS */), [
                        [_vModelSelect, _ctx.visitDetails.TypeId]
                      ]),
                      (_ctx.v$.visitDetails.TypeId.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Reason Type is required."))
                        : _createCommentVNode("v-if", true),
                      (_ctx.cpyTrackingReason.length > 0)
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 1,
                            id: "reason",
                            name: "reason",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visitDetails.ReasonId) = $event)),
                            class: _normalizeClass(`form-select mt-3 ${!_ctx.v$.visitDetails.ReasonId.$error ? '' : 'field-invalid'}`),
                            onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.visitDetails.ReasonId.$touch && _ctx.v$.visitDetails.ReasonId.$touch(...args)))
                          }, [
                            _hoisted_15,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cpyTrackingReason, (trackingReason) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: trackingReason.Id,
                                key: trackingReason.Id
                              }, _toDisplayString(trackingReason.Reason), 9 /* TEXT, PROPS */, _hoisted_16))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 34 /* CLASS, HYDRATE_EVENTS */)), [
                            [_vModelSelect, _ctx.visitDetails.ReasonId]
                          ])
                        : _createCommentVNode("v-if", true),
                      (_ctx.cpyTrackingReason.length > 0 && _ctx.v$.visitDetails.ReasonId.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Tracking Reason is required."))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["application-id"]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (_ctx.isSaving)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_21))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", _hoisted_22, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.reassignVisit()))
            }, "Reassign"),
            _createElementVNode("button", {
              type: "button",
              class: "ms-1 btn btn-md btn-outline-secondary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancel()))
            }, "Cancel")
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}